/**
 * @generated SignedSource<<60c00fae2159fe8cad5b1f0290338819>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraPriorityField_Platform$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
  } | null;
  readonly priorities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly iconUrl: AGG$URL | null;
        readonly name: string | null;
        readonly priorityId: string;
      } | null;
    } | null> | null;
  } | null;
  readonly priority: {
    readonly iconUrl: AGG$URL | null;
    readonly name: string | null;
    readonly priorityId: string;
  } | null;
  readonly " $fragmentType": "JiraPriorityField_Platform";
};
export type JiraPriorityField_Platform$key = {
  readonly " $data"?: JiraPriorityField_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraPriorityField_Platform">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "priorityId"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "iconUrl"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraPriorityField_Platform",
  "selections": [
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    },
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "JiraPriorityConnection",
      "kind": "LinkedField",
      "name": "priorities",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraPriorityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraPriority",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v0/*: any*/)
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraPriorityField"
};
})();

(node as any).hash = "116f0c33db1e8652714194faaad6b2a8";

export default node;
